import { z } from 'zod';
import { claimFlexWorkerSchema } from '../platform-worker/platform-worker-service.schema';

const noShowReasonSchema = z.object({
  id: z.string(),
  longDescription: z.string(),
  shortDescription: z.string(),
  enabledForSelection: z.boolean(),
  allowsConsequences: z.boolean(),
  affectsAttendanceRate: z.boolean(),
});

const checkedInIndicatorSchema = z.object({
  visible: z.boolean(),
  dateTime: z.string(),
});

const claimDetailsCommonSchema = z.object({
  claimId: z.string(),
  hourlyRateCents: z.number(),
  ratingPercentage: z.number().optional(),
  attendanceRate: z.number().optional(),
  isReplacement: z.boolean(),
  lenderCompanyName: z.string().nullable(),
  includeCheckedInIndicator: checkedInIndicatorSchema,
  flexWorker: claimFlexWorkerSchema,
});

const claimAcceptedSchema = claimDetailsCommonSchema.extend({
  state: z.enum(['accepted', 'checkoutSettled', 'checkoutPending', 'counterOffer']),
});

const claimCanceledSchema = claimDetailsCommonSchema.extend({
  state: z.enum(['canceled', 'cancelationOfferPending', 'cancelationOfferSettled']),
  cancelationActor: z.enum(['unknown', 'byFW', 'byOG', 'byHQ']),
});

const claimAcceptedNoShowSchema = claimDetailsCommonSchema.extend({
  state: z.literal('noShow'),
  noShowReason: noShowReasonSchema,
});

export const claimDetailsSchema = z.union([
  claimAcceptedSchema,
  claimCanceledSchema,
  claimAcceptedNoShowSchema,
]);
